
  import { defineComponent, PropType } from 'vue';

  import { TStorePaths } from '@/common/types/storePaths';

  import {
    ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME,
    ANALYTICS_NOTES_MONTHLY_GETTERS_NAME,
    ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME,
  } from '../../store/analyticsNotesMonthly/name';
  import {
    ANALYTICS_NOTES_YEARLY_ACTIONS_NAME,
    ANALYTICS_NOTES_YEARLY_GETTERS_NAME,
    ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME,
  } from '../../store/analyticsNotesYearly/name';
  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import AnalyticsNotesStructureTable from './AnalyticsNotesStructureTable.vue';

  export default defineComponent({
    name: 'AnalyticsNotesStructureImportTable',
    components: {
      AnalyticsNotesStructureTable,
    },
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getStorePaths(): TStorePaths {
        return this.isMonthly
          ? {
              action: ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchImportStructureTable,
              getter: ANALYTICS_NOTES_MONTHLY_GETTERS_NAME.getImportStructureTable,
              mutation: ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME.setImportStructureTable,
            }
          : {
              action: ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchImportStructureTable,
              getter: ANALYTICS_NOTES_YEARLY_GETTERS_NAME.getImportStructureTable,
              mutation: ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME.setImportStructureTable,
            };
      },
    },
  });
